import { Component, Input } from '@angular/core';
import { Message } from 'src/app/shared/models/message.model';


@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss']
})
export class ChatMessageComponent {
  @Input() isOwner: boolean = true;
  @Input() data!: Message;
}
